/**
 * How a Tigaly plan from GET /stripe/plans reads on screen. Shared by the
 * pricing modal and the Subscription card in Settings.
 */
export const formatEur = amount => `€${Number(amount).toFixed(2).replace(/\.00$/, '')}`;

export const priceLabel = plan => `${formatEur(plan.amount)}${plan.interval ? '/month' : ' once'}`;

export const limitRows = plan => [
  ['Leads per month', plan.limits.linkedin_scraper.toLocaleString('en-US')],
  ['AI usage', plan.byok ? 'Unlimited on your own AI API key' : `${plan.limits.ai_home} credits/mo`],
  ['LinkedIn profiles', plan.limits.linkedin_profile],
  ['Email accounts', 'Unlimited'],
];

export const extraRows = plan => [
  `Extra LinkedIn profile ${formatEur(plan.extras.linkedinProfile)}/mo`,
  ...(plan.extras.aiCredit ? [`Extra AI credit ${formatEur(plan.extras.aiCredit)}`] : []),
  ...(plan.whiteLabel ? ['All future product updates', 'White-labeling for agencies'] : []),
];

export const seatsLabel = plan =>
  plan.key === 'lifetime'
    ? `Only ${plan.seats.total} lifetime deals · ${plan.seats.left} left`
    : `First ${plan.seats.total} only · ${plan.seats.left} of ${plan.seats.total} seats left`;

export const termsNote = plan =>
  plan.key === 'lifetime'
    ? `${formatEur(plan.amount)} once. No monthly fee.`
    : `${plan.trialDays} days free, then ${formatEur(plan.amount)} a month. Cancel anytime.`;

/** The plan the user's active or trialing subscription is on, if it is a Tigaly plan. */
export const findCurrentPlan = (plans, subscription) =>
  ['active', 'trialing'].includes(subscription?.status)
    ? plans.find(plan => plan.priceIds.includes(subscription?.priceId)) || null
    : null;
